import apiService from './apiService';

export interface AppleHealthIntegration {
  id: string;
  userId: string;
  deviceId: string | null;
  isActive: boolean;
  lastSyncedAt: string | null;
  connected: boolean;
  createdAt: string;
  updatedAt: string;
}

export const appleHealthService = {
  /**
   * Get user's Apple Health integrations
   */
  async getIntegrations(): Promise<AppleHealthIntegration[]> {
    return apiService.get('/health/apple/integrations');
  },

  /**
   * Disconnect an Apple Health integration
   * Note: Connect is only available on iOS mobile app
   */
  async disconnectAppleHealth(integrationId: string): Promise<void> {
    return apiService.delete(`/health/apple/integrations/${integrationId}`);
  },
};
